import { noteItemsOf } from '@inflip/shared';

/** 판매자 주의·규칙 사항·특약 — 한 줄이 한 항목, 번호는 표시할 때 붙인다 (웹 components/note-items 와 같은 규칙) */
export function NoteItems({
  text,
  className,
}: {
  text: string | null | undefined;
  className?: string;
}) {
  const items = noteItemsOf(text);
  if (items.length === 0) return null;
  return (
    <ol className={['space-y-1', className].filter(Boolean).join(' ')}>
      {items.map((item, i) => (
        <li key={i} className="flex gap-1.5">
          <span className="shrink-0 tabular-nums">{i + 1}.</span>
          <span className="min-w-0 break-words">{item}</span>
        </li>
      ))}
    </ol>
  );
}
